export default {
  getUsersCount(state, _getters) {
    return state.ids.length;
  },
  // (state, getters, rootState, rootGetters) { }
};
